import queryString from "query-string"
import { useSelector } from "react-redux"
import { getPartnerFirstName } from "reducers/userInfo"
import { FleLayout } from "components/views/fle/FleLayout"
import { TopSection } from "components/views/fle/TopSection"
import { BackArrow, ContinueArrow, SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { IlloWhereAreYouMap } from "components/views/atoms/Illustrations"
import { Body, BodySmall } from "components/views/atoms/Bodies"
import { FleLinkWrapper } from "components/views/atoms/Links"
import { TextLink } from "components/views/atoms/links/TextLink"
import React from "react"

const JourneyIntro = ({ next, skip, location }) => {
  const { isEntryPoint } = queryString.parse(location.search)
  const partnerFirstName = useSelector(getPartnerFirstName)

  const entryPointTitle = partnerFirstName
    ? "Let’s get an idea of where you and your partner are today."
    : "Let’s get an idea of where you are today."

  const nonEntryPointtitle = partnerFirstName
    ? "Finally, let’s get an idea of where you and your partner are today."
    : "Finally, let’s get an idea of where you are today."

  return (
    <FleLayout>
      <TopSection progressStep={4} leftOrBackArrow={<BackArrow />} />
      <FlexRowCenter>
        <IlloWhereAreYouMap />
      </FlexRowCenter>
      <SpacerSwitcher />
      <SwitchH1ToH2>{isEntryPoint ? entryPointTitle : nonEntryPointtitle}</SwitchH1ToH2>
      <Spacer height={1} />
      <Body color="black-80">
        Your answers help us provide relevant information and a more personalized Carrot experience.
      </Body>
      <FleLinkWrapper>
        <ContinueArrow to={next} />
        {!isEntryPoint && (
          <TextLink to={skip}>
            <BodySmall color="black-80">Skip section</BodySmall>
          </TextLink>
        )}
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { JourneyIntro }
